<script lang="ts">import { Button } from "@infinitro/button";
import { t, Verbiage } from "@infinitro/content";
import { ModalDialog, modalStack, popModal } from "@infinitro/global";
import { WarningNewIcon } from "@infinitro/icons";
import { derived } from "svelte/store";
import Modal from "../modal.svelte";
const thisModal = ModalDialog.Confirmation;
const modalIndex = derived(modalStack, ($modalStack) => $modalStack.findIndex((e) => e.modal === thisModal));
const isModalOpen = derived(modalIndex, ($modalIndex) => $modalIndex >= 0);
const payload = derived(modalStack, ($modalStack) => $modalStack.find((e) => e.modal === thisModal)?.data);
const zOverlay = derived(modalIndex, ($modalIndex) => $modalIndex >= 0 ? 9999 + $modalIndex * 2 : 9999);
const closeModal = () => popModal(thisModal);
let errors = new Set();
function addError(message) {
	errors.clear();
	errors.add(message);
	errors = new Set(errors);
}
function clearErrors() {
	errors.clear();
	errors = new Set(errors);
}
const handleRightButtonClick = async () => {
	try {
		if ($payload?.onRightButtonClick) {
			const [pass, errorMessage] = await $payload.onRightButtonClick();
			if (pass === false) {
				addError(errorMessage ?? "unknown error");
				return;
			}
		}
		closeModal();
	} catch (e) {
		console.warn("error handling right button click", e);
		addError(e);
	}
};
const handleLeftButtonClick = async () => {
	try {
		if ($payload?.onLeftButtonClick) {
			const [pass, errorMessage] = await $payload.onLeftButtonClick();
			if (pass === false) {
				addError(errorMessage ?? "unknown error");
				return;
			}
		}
		closeModal();
	} catch (e) {
		console.warn("error handling left button click", e);
		addError(e);
	}
};
const handleClose = async () => {
	try {
		if ($payload?.onClose) {
			const pass = await $payload.onClose();
			if (pass === false) return;
		}
		closeModal();
	} catch (e) {
		console.warn("error handling close", e);
		addError(e);
	}
};
</script>

{#if isModalOpen}
	<Modal
		title={$payload?.title}
		closeModal={handleClose}
		width="450px"
		maxWidth="90vw"
		noAnimation={$modalIndex > 0 || ($payload?.noAnimation ?? false)}
		zIndexOverlay={$zOverlay}
		zIndexUnderlay={$zOverlay - 1}
	>
		<div class="confirmation-content">
			{#if errors.size > 0}
				<div class="error-box">
					<WarningNewIcon />
					<small class="withdraw-disclaimer">
						<strong>{`${$t(Verbiage.error)}:`}</strong>
						<span>{Array.from(errors).join(' ')}</span>
					</small>
				</div>
			{/if}
			<p class="description">
				{#if $payload?.content}
					{$payload.content}
				{/if}
			</p>
			<div class="actions">
				<Button
					variant={$payload?.leftButtonVariant ?? 'tertiary'}
					text={$payload?.leftButtonText}
					onClick={handleLeftButtonClick}
					size="medium"
					fullWidth
				/>
				<Button
					variant={$payload?.rightButtonVariant ?? 'primary'}
					text={$payload?.rightButtonText}
					onClick={handleRightButtonClick}
					size="medium"
					fullWidth
				/>
			</div>
		</div>
	</Modal>
{/if}

<style>
	.confirmation-content {
		display: flex;
		flex-direction: column;
		gap: 1.5rem;
}

	.description {
		margin: 0px;
		font-size: 0.875rem;
		line-height: 1.25rem;
		color: var(--color-text-100);
}

	.actions {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 0.75rem;
}

	.error-box {
		display: flex;
		width: 100%;
		align-items: center;
		gap: 0.5rem;
		border-radius: 0.5rem;
		background-color: var(--component-error-background);
		padding: 0.5rem;
		text-align: start;
		color: var(--component-error-text);
}

	.error-box :global(svg) {
		color: inherit;
		flex-shrink: 0;
	}

	.withdraw-disclaimer {
		font-size: 0.75rem;
		line-height: 1rem;
		color: inherit;
}
</style>
